import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Send } from 'lucide-react';
export function CTA() {
  const [email, setEmail] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setShowSuccess(true);
    setEmail('');
    setTimeout(() => setShowSuccess(false), 3000);
  };
  return <section id="cta" className="py-20 px-4 bg-gradient-to-br from-purple-600 via-pink-600 to-blue-600 relative overflow-hidden" data-id="element-11">
      {/* Animated Stars Background */}
      {[...Array(12)].map((_, i) => <motion.div key={i} className="absolute" style={{
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`
    }} animate={{
      y: [0, -30, 0],
      rotate: [0, 360],
      scale: [1, 1.5, 1]
    }} transition={{
      duration: 4 + Math.random() * 2,
      repeat: Infinity,
      delay: Math.random() * 2
    }} data-id="element-12">
          <Sparkles className="text-yellow-300 opacity-60" size={24} data-id="element-13" />
        </motion.div>)}

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-15">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-16">
            Ready to Level Up Your Education Brand?
          </h2>
          <p className="text-xl md:text-2xl text-white/90 mb-12" data-id="element-17">
            Join the schools and EdTech companies transforming their outreach
            with Goblincamp
          </p>

          <form onSubmit={handleSubmit} className="max-w-xl mx-auto" data-id="element-18">
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-19">
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email" required className="flex-1 px-6 py-4 rounded-full text-lg focus:outline-none focus:ring-4 focus:ring-yellow-300" data-id="element-20" />
              <motion.button type="submit" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="bg-yellow-400 text-gray-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-300 transition-colors flex items-center justify-center gap-2 shadow-xl" data-id="element-21">
                Get Started
                <Send size={20} data-id="element-22" />
              </motion.button>
            </div>
          </form>

          {showSuccess && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="mt-6 bg-white/20 backdrop-blur-sm text-white px-6 py-3 rounded-full inline-block" data-id="element-23">
              ✨ Thanks! We'll be in touch soon!
            </motion.div>}

          <p className="text-white/80 mt-8 text-sm" data-id="element-24">
            No spam, just magical educational marketing insights
          </p>
        </motion.div>
      </div>
    </section>;
}